import { Component, ViewChild, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';
import { Router, NavigationEnd } from '@angular/router';

/*Services */
import { StateService, CommandsService, SettingsService, CachedDataService, AuthService, DevicesService, AppService } from '@services';

/*Models */
import { Device } from '@models/device';
import { ObservableObject } from '@models/observable-object';

/*Plugins */
import { BsModalComponent } from 'ng2-bs3-modal';

import { SettingTemplateNodeItem } from "@models"

declare var swal: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'settings-modal',
  templateUrl: './settings-modal.component.html'
})

export class SettingsComponent implements OnDestroy {
  @ViewChild('settingsComponent') settingsComponent: BsModalComponent;
  @ViewChild('changeObjectNameModal') changeObjectNameModal;
  @ViewChild('changeDevicePhoneModal') changeDevicePhoneModal;

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  public newCommandsGroup: Array<any> = [];
  public editCommandsGroup: Array<any> = [];
  public cCode: string = null;
  public ifLoadCommand = false;
  public currentDevice: Device;
  ifChangeTimer = false;
  ifShowCcode = false;
  ifLoading = false;
  settingsTemplate: Array<SettingTemplateNodeItem> = [];
  currentSettingsValue;
  currentTemplate;
  newSettingsSet = [];
  timersListAll;
  timersListTime;
  timersListTemp;
  canShowTime = true;
  conditionParametrs = [];
  submitForm = false;
  ifCurrentPandora = false;
  observableObject: ObservableObject;

  phoneNumberModel;
  currentTimersSupport:Array<
    {
      groupId: string;
      type: string;
    }
  >
  constructor(
    private commandsService: CommandsService,
    private settingsService: SettingsService,
    private stateService: StateService,
    private cachedDataService: CachedDataService,
    private authService: AuthService,
    private appService: AppService,
    private devicesService: DevicesService,
    private router: Router
  ) {

    router.events.subscribe(event => {
      if (event instanceof NavigationEnd && event.url.indexOf('online') < 0) {
        this.close();
      }
    });

    this.cCode = this.cachedDataService.getCcode();
    this.observableObject = this.cachedDataService.getCurrentObject();



    this.currentDevice = this.stateService.currentDevice;
    console.log(this.currentDevice)
    this.checkIfShowCcode();

    this.stateService.currentDeviceObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(device => {
        this.ifLoading = false;
        this.currentDevice = device;
        this.settingsTemplate = [];
        this.currentSettingsValue = null;
        this.checkIfShowCcode();
        this.checkIfShowTimer();
      });

    this.settingsService.openSettingsObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe((value) => {
        this.open(value);
      });

    this.commandsService.ifLoadCommandObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(value => {
        this.ifLoadCommand = value;
      });

    this.stateService.updateDevicePhoneObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(number => {
        this.currentDevice.phones[0].number = number;
      });

    this.commandsService.getCommandsGroupObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(() => {
        this.loadCommandsGroups();
      });

    this.stateService.observableObjectObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(object => {
        this.observableObject = object;
      });

  }
  getTimers() {
    this.settingsService.getTimers(this.currentDevice.id, this.currentDevice.provider).subscribe(response => {
      this.timersListAll = response;
      this.timersListTime = this.timersListAll.filter(timer => timer.type === 'time');
      this.timersListTemp = this.timersListAll.filter(timer => timer.type === 'temperature');
    });
  }
  getSettings(ifOpenCommand) {
    this.ifLoading = true;
    this.settingsService.getSettings(this.currentDevice.id, this.currentDevice.provider).subscribe((result) => {
      console.log(JSON.stringify(result))
      this.settingsTemplate = [];
      this.conditionParametrs = [];
      if (result && result.settingsTemplate) {
        /*temp array to exclude duplicate */
      //  const tempArray = [];
        this.settingsTemplate = result.settingsTemplate.nodes.filter(item=>item.type=="category");
        result.settingsTemplate.nodes.filter(item=>item.type=="section").map(item=>{
         let parent=  this.settingsTemplate.filter(parentItem=>parentItem.id== item.parentId)[0];
          if(parent){
            if(! parent.sections){
              parent.sections = []
            }

            parent.sections.push(item)
           
          }

        })

        console.log(this.settingsTemplate)
        this.currentSettingsValue = result.settings;
        this.currentTimersSupport = result.settingsTemplate.timersSupport
        


        result.settingsTemplate.parameters.map(parametr => {
          // if (parametr.settingsTemplateParametersGroup && tempArray.indexOf(parametr.settingsTemplateParametersGroup.id) < 0) {
          //   /*if not yet added */
          //   tempArray.push(parametr.settingsTemplateParametersGroup.id);
          //   parametr.settingsTemplateParametersGroup['items'] = [];
          //   this.settingsTemplate.push(parametr.settingsTemplateParametersGroup);
          // }

          // if (parametr.condition) {
          //   /*Если этот параметр может выключаться */

          //   /*По дефолту всегда выключаем переключаемые параметры */
          //   parametr['disabled'] = false;


          //   if (!this.conditionParametrs.filter(item => item.code === parametr.condition.code).length) {
          //     /* Если ранее не добавлялл переключатель параметров */
          //     const data = {
          //       code: parametr.condition.code,
          //       value: parametr.condition.value,
          //     };

          //     const conditionValue = this.currentSettingsValue.filter(item => item.code === parametr.condition.code)[0];
          //     if (conditionValue) {
          //       /*Если значение переключателя пришло с бека */
          //       data.value = conditionValue.value;
          //     }

          //     this.conditionParametrs.push(data);
          //   }
          // }


        });


        /*sorted by order */
        this.settingsTemplate = this.appService.sortedArray(this.settingsTemplate, 'order');
        this.settingsTemplate.map(category=>{
          if(category.sections){
            category.sections = this.appService.sortedArray(category.sections, 'order');
          }
        })

        result.settingsTemplate.parameters.map(parametr => {

          /*Добавляем значения */
          const item = this.currentSettingsValue.filter(value => value.code === parametr.code)[0];

          if (!item || !item.value) {
            // не пришло значение - значит не выводим полей вообще
            return;
          }
          parametr.valueArray = item;

          /*Добавляем значения */

          /*Находим текущую категорию настроек */
          let currentTemplate;
          this.settingsTemplate.map(category=>{
            if(category.id==parametr.settingsTemplateNodeId){
              currentTemplate = category;
              return;
            }else if(category.sections && category.sections.length){
              category.sections.map(section=>{
                if(section.id==parametr.settingsTemplateNodeId){
                  currentTemplate = section;
                  return;
                }
              })
            }
          })
      //  = this.settingsTemplate.filter(item => item.id === parametr.settingsTemplateNodeId)[0];

          if (parametr.code) {

            if (parametr.valueInverse) {
              
              parametr.valueArray['initialValue'] = parseFloat(parametr.valueArray.value.toString());
              parametr.valueArray.value = (parseFloat(parametr.maxValue) - parseFloat(parametr.valueArray.initialValue.toString())) + parseFloat(parametr.minValue.toString());

            }

            if (parametr.valueFactor) {
              parametr.minValue = (parseFloat(parametr.minValue) * parametr.valueFactor).toFixed(2);
              parametr.maxValue = (parseFloat(parametr.maxValue) * parametr.valueFactor).toFixed(2);
              parametr.valueArray.value = (parseFloat(parametr.valueArray.value.toString()) * parametr.valueFactor).toFixed(2);
            }

            // if (parametr.condition) {
            //   const currentCondition = this.conditionParametrs.filter(condition => condition.code === parametr.condition.code)[0];

            //   if (parametr.disabledValue && parametr.disabledValue === parametr.valueArray.value) {
            //     currentCondition.value = 'false';
            //     parametr['disabled'] = true;
            //   }
            //   if (!parametr.disabledValue) {
            //     /*Если нет значения для выключения, значит параметр пришел с бека */
            //     if (currentCondition.value === 'false') {
            //       parametr['disabled'] = true;
            //     }
            //   }

            // }
            if(!currentTemplate['items']){
              currentTemplate['items'] = []
            }
            currentTemplate['items'].push(parametr);
          }


        });



         this.settingsTemplate.map((template, index) => {


          if (!template.items || !template.items.length) {
            this.settingsTemplate.splice(index, 1);
            return;
          }

           template.items = this.appService.sortedArray(template.items, 'order');

        //   template.items.map(item => {
        //     if (!item.valueArray) {
        //       /*Если это выключатель и у него нет значения с бека - добавляем ему значение */
        //       const condition = this.conditionParametrs.filter(param => param.code === item.code)[0];
        //       if (condition) {
        //         item['valueArray'] = condition;
        //       }
        //     }

        //   });

         });

      }


      /*push last template */
      this.settingsTemplate.push({
        id: 'fab',
        title: 'Управление быстрыми командами (FAB)'
      });
      this.settingsTemplate.unshift({
        id: 'auth',
        title: 'Авторизация'
      });


      /*Select first is active */
      if (ifOpenCommand) {
        this.currentTemplate = this.settingsTemplate[this.settingsTemplate.length - 1];
      } else {
        this.currentTemplate = this.settingsTemplate[0];
      }
  
      this.ifLoading = false;

    }, (error) => {
      let errorMessage = 'Ошибка, попробуйте позже';
      if (error && error.error.errorMessage && error.error.errorMessage.length) {
        errorMessage = error.error.errorMessage;
      }
      swal({
        type: 'error',
        text: errorMessage,
        showConfirmButton: true
      });
    
      this.ifLoading = false;
      this.close()
    });
  }



  checkIfShowCcode() {
    if (this.currentDevice && this.currentDevice.provider.toLowerCase() === 'magicsystems') {
      this.ifShowCcode = true;
    } else {
      this.ifShowCcode = false;
    }
  }

  checkIfShowTimer() {
    if (this.currentDevice.provider.toLowerCase() === 'magicsystems' || this.currentDevice.provider.toLowerCase() === 'pandora') {
      this.canShowTime = true;
    } else {
      this.canShowTime = false;
    }

    if (this.currentDevice.provider.toLowerCase() === 'pandora') {
      this.ifCurrentPandora = true;
    } else {
      this.ifCurrentPandora = false;
    }
  }

  reset() {
    this.timersListAll = null;
    this.timersListTime = null;
    this.timersListTemp = null;
    this.settingsTemplate = [];
    // this.editCommandsGroup = null;

  }

  selectTab(value) {
    this.currentTemplate = value;
  }

  loadCommandsGroups() {

    const selectedGroupCommand = this.cachedDataService.getSelectedGroupCommand();
    this.newCommandsGroup = JSON.parse(JSON.stringify(this.commandsService.commandsGroup));
    if (selectedGroupCommand) {
      /*load selected group command */
      this.newCommandsGroup.map((command) => {
        selectedGroupCommand.map((selectCommand) => {
          if (command.key === selectCommand.key) {
            command.checked = selectCommand.checked;
          }
        });
      });
    }
    this.editCommandsGroup = JSON.parse(JSON.stringify(this.newCommandsGroup));
  }

  open(ifOpenCommand) {
    /*copy the data model so that it does not change before clicking on the button*/
    if (!this.ifLoading) {
      if (this.canShowTime) {
        this.getTimers();
      }

      this.getSettings(ifOpenCommand);
      if (!this.newCommandsGroup.length) {
        this.ifLoadCommand = true;
        this.commandsService.getCommand();
      } else {
        this.editCommandsGroup = JSON.parse(JSON.stringify(this.newCommandsGroup));
      }
      this.newSettingsSet = [];
    }

    this.settingsComponent.open();
  }

  close() {
    this.ifChangeTimer = false;
    this.settingsComponent.close();
  }

  save() {




    /*save selected group commands on click save button */
    if (this.submitForm) {
      return;
    }
    this.cachedDataService.setCcode(this.cCode);
    this.stateService.addCcodeEvent.emit();
    this.newCommandsGroup = JSON.parse(JSON.stringify(this.editCommandsGroup));
    this.saveComandsGroups(this.newCommandsGroup);
    this.commandsService.getCommandsGroupSubject.next(this.newCommandsGroup);


    if (this.timersListTime && this.timersListTemp && this.canShowTime) {
      const ifShowAlert = this.newSettingsSet.length === 0 && this.ifChangeTimer;
      this.saveTimer(ifShowAlert);
    }



    // if (this.phoneNumberModel !== this.currentDevice.phones[0].number) {


    // }

    if (!this.newSettingsSet.length) {
      this.submitForm = false;
      this.close();
      return;
    }
    this.submitForm = true;


    if (this.newSettingsSet.length) {
      this.settingsService.saveSettings(this.currentDevice.id, this.newSettingsSet).subscribe(
        response => {
          this.submitForm = false;
          if (this.newSettingsSet.length || this.ifChangeTimer) {
            setTimeout(() => {
              swal({
                type: 'success',
                text: 'В течении нескольких минут настройки будут сохранены.',
                showConfirmButton: false,
                timer: 3000,
              });
            }, 500);
            this.close();
          }

        }, error => {
          this.submitForm = false;
          let errorMessage = 'Ошибка, попробуйте позже';
          if (error.error && error.error.errorMessage && error.error.errorMessage.length) {
            errorMessage = error.error.errorMessage;
          }
          swal({
            type: 'error',
            text: errorMessage,
            showConfirmButton: true
          });
        }
      );

    }
  }
  saveTimer(ifShowAlert) {

    Array.prototype.push.apply(this.timersListTime, this.timersListTemp);

    this.settingsService.setTimers(this.currentDevice.id, this.timersListTime).subscribe(response => {
      if (ifShowAlert) {
        setTimeout(() => {
          swal({
            type: 'success',
            text: 'В течении нескольких минут таймеры будут сохранены.',
            showConfirmButton: false,
            timer: 3000,
          });
        }, 500);
        this.close();
      }

    }, error => {
      let errorMessage = 'Ошибка, при сохранении таймеров';
      if (error.error && error.error.errorMessage && error.error.errorMessage.length) {
        errorMessage = error.error.errorMessage;
      }
      swal({
        type: 'error',
        text: errorMessage,
        showConfirmButton: true
      });
    });

  }

  saveComandsGroups(saveGgroups) {
    /*cashed selected group commands */
    const currentGroups = this.cachedDataService.getSelectedGroupCommand();
    let writeArray = [];
    if (currentGroups) {
      /*ih has selected */
      saveGgroups.map((group) => {
        const currentHasSave = currentGroups.filter(selectedGroup => selectedGroup.key === group.key);

        if (!currentHasSave.length && group.checked) {
          /*if new group and is she checked */
          currentGroups.push(group);
        } else {
          if (!group.checked) {
            /*delete group from current */
            const index = currentGroups.indexOf(currentHasSave[0], 0);
            if (index > -1) {
              currentGroups.splice(index, 1);
            }
          }
        }
      });
      writeArray = currentGroups;
    } else {
      /*if no selected, write new commands */
      writeArray = saveGgroups.filter((command) => command.checked);
    }
    if (!writeArray.length) {
      /*if noe commands - delete drom localStorage */

      this.cachedDataService.clearSelectedGroupCommand();

    } else {
      /*if has commands */
      this.cachedDataService.setSelectedGroupCommand(writeArray);
    }
  }
  changeSettingsValue(event, type, valueArray, setting?) {

    let value;

    const array = {
      code: null,
      value: null
    };
    if (type === 'range') {
      value = event.from;
    } else if (type === 'checkbox') {
      value = event.target.checked;
    }else if(type==="list"){
      value =  valueArray.value;
     
    }else if(type==="phone"){
      value = event.replace(/\D/g, '')
    } else if(type==="bitmask"){
      value = event;
    }
    valueArray.value = value;
    // const condition = this.conditionParametrs.filter(param => param.code === valueArray.code)[0];
    // let conditionSettingData;





    // if (condition) {
    //   /*if checkbox has condition */

    //   this.settingsTemplate.map(setting => {
    //     if (setting.items) {
    //       setting.items.map(item => {
    //         if (item.condition && item.condition.code === condition.code) {
    //           /*Проходимся по настройкам и выключаем все параметры*/
    //           item['disabled'] = !value;
    //           conditionSettingData = item;
    //         }
    //       });
    //     }

    //   });
    //   array.code = conditionSettingData.valueArray.code;


    //   const conditionFromApi = this.currentSettingsValue.filter(item => item.code === valueArray.code)[0];

    //   if (conditionFromApi) {
    //     /*Если значение этого параметра пришло с бека, тогда отправляем его же */
    //     array.code = valueArray.code;
    //     array.value = valueArray.value;
    //   } else {
    //     /*Если значение этого параметра не пришло с бека, отправляем значения не из выключателя а из выключаемого*/
    //     if (value) {
    //       /*Если включили - изначально передаем минимальное значение */
    //       array.value = conditionSettingData.minValue;
    //     } else {
    //       /*Если выключили - тода передаем значение из disabledValue */
    //       array.value = parseFloat(conditionSettingData.disabledValue);
    //     }
    //   }


    // } else {

      array.code = valueArray.code;
      array.value = valueArray.value;
    //}

    if (setting && setting.valueInverse && setting.type === 'Range') {
      array.value = (setting.maxValue - value) + setting.minValue;
    }

    if (setting && setting.valueFactor && setting.type === 'Range') {
      array.value = value / setting.valueFactor;
    }

    if (this.newSettingsSet && this.newSettingsSet.filter(item => item.code === array.code).length) {
      this.newSettingsSet.filter(item => item.code === array.code)[0].value =   typeof array.value === 'string' ? array.value : JSON.stringify(array.value);
    } else {
      array.value =   typeof array.value === 'string' ? array.value : JSON.stringify(array.value)
      this.newSettingsSet.push(array);
    }
  }

  onAddTimer(event) {
    this.ifChangeTimer = true;
    if (event.type === 'time') {
      this.timersListTime.push(event);
      this.timersListTime = this.timersListTime.slice(0);
    } else {
      this.timersListTemp.push(event);
      this.timersListTemp = this.timersListTemp.slice(0);
    }
  }

  onDeleteTimer(timersList, type) {
    this.ifChangeTimer = true;
    if (type === 'time') {
      this.timersListTime = timersList;
    } else {
      this.timersListTemp = timersList;
    }
  }

  myOnChange(event, setting) {
    const range = document.getElementsByClassName('range-' + setting + '-js')[0];
    if (range.classList.contains('range-showMinMax')) {
      range.classList.remove('range-showMinMax--max');
      range.classList.remove('range-showMinMax--min');
      if (parseFloat(event.from) === event.max) {
        range.classList.add('range-showMinMax--max');
      }
      if (parseFloat(event.from) === event.min) {
        range.classList.add('range-showMinMax--min');
      }
    }

  }
  getPhoneValue(){
    if(this.currentDevice.phones && this.currentDevice.phones.length){
      return this.currentDevice.phones.filter(phone => phone.usageType == "main")[0].number;
    }else{
      return ''
    }
  }
  changePassword() {
    this.authService.userUpdatePasswordSubject.next();
  }

  onChangeUsername(event) {
    this.phoneNumberModel = event;
  }

  changeObjectName() {
    this.changeObjectNameModal.open();
  }

  changeDevicePhone() {
    this.changeDevicePhoneModal.open();
  }
  checkTimerSupport(templateId: string){
    if(!this.currentTimersSupport){
      return false;
    }
   return this.currentTimersSupport.filter(item=>item.groupId==templateId).length>0;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/view/modal/settings-modal/settings-modal.component.ts